import { CompanyType } from '@/types/CompanyType'
import { setUriId } from '@/utils/Functions'
import React from 'react'
import { Alert, Card, Col, Row } from 'react-bootstrap'

type Props = {
  memberships: undefined | CompanyType[]
}

export const MemberShipListTable: React.FC<Props> = ({ memberships }: Props) => {
  /* Render
   *******************************************************************************************/
  return (
    <Card>
      <Card.Header>
        <Row>
          <Col>
            <h5 className='mt-2'>Sociétés affectés</h5>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        {memberships?.length === 0 ? (
          <Alert variant='light' className='text-center pb-5'>
            <i className='ri-information-line ri-4x'></i>
            <br />
            Aucune affection !
            <br />
          </Alert>
        ) : (
          <>
            <Row>
              <Col md={1} className='d-none d-md-block'>
                <b>#</b>
              </Col>
              <Col md={2} className='d-none d-md-block'>
                <b>Nom</b>
              </Col>
              <Col md={3} className='d-none d-md-block'>
                <b>Client/Organisation</b>
              </Col>
              <Col md={3} className='d-none d-md-block'>
                <b>Email</b>
              </Col>
              <Col md={3} className='d-none d-md-block'>
                <b>Téléphone</b>
              </Col>
            </Row>
            <hr className='d-none d-md-block' />
            {memberships?.map((company, indx: number) => {
              const isLast = indx !== memberships.length - 1
              return (
                <React.Fragment key={company.id}>
                  {/* <Link to={'/societes/detail/' + setUriId(company['@id'])}> */}
                  <Row className='text-center text-md-start rounded-4 p-3'>
                    <Col md={1} className='d-none d-md-block mb-2 mb-md-0' key={company.id}>
                      {setUriId(company['@id'])}
                    </Col>
                    <Col md={2} className='mb-2 mb-md-0'>
                      {company?.name}
                    </Col>
                    <Col md={3} className='d-none d-md-block mb-2 mb-md-0'>
                      {company?.contactName}
                    </Col>
                    <Col md={3} className='mb-2 mb-md-0'>
                      {company?.contactEmail}
                    </Col>
                    <Col md={3} className='mb-2 mb-md-0'>
                      {company?.contactPhone}
                    </Col>
                  </Row>
                  {/* </Link> */}
                  {isLast && <hr className='mt-4' />}
                </React.Fragment>
              )})}
          </>
        )}
      </Card.Body>
    </Card>
  )
}
